import React from 'react';

type HeadingProps = {
  item: {
    level: number;
  };
  children: [];
};

export default function Heading({ item, children }: HeadingProps) {
  if (item.level === 1) {
    return <h1>{children}</h1>;
  }
  if (item.level === 2) {
    return <h2>{children}</h2>;
  }
  if (item.level === 3) {
    return <h3>{children}</h3>;
  }
  if (item.level === 4) {
    return <h4>{children}</h4>;
  }
  if (item.level === 5) {
    return <h5>{children}</h5>;
  }
  if (item.level === 6) {
    return <h6>{children}</h6>;
  }

  return <>{children}</>;
}
